export default {"src":"/_next/static/media/viewers4.f92de561.svg","height":1070,"width":1340};